import React, { useState } from "react";

import placeholderSrc from "../../assets/images/tournament_badge_placeholder.svg";

/**
 * TournamentBadge - Tournament logo with automatic placeholder fallback
 *
 * Props:
 *   src       - image URL (optional)
 *   alt       - alt text (defaults to "Tournament")
 *   className - classes applied to the img element (e.g. "w-8 h-8 rounded-lg object-cover")
 */
const TournamentBadge = ({ src, alt = "Tournament", className = "" }) => {
  const [imgSrc, setImgSrc] = useState(src || placeholderSrc);

  const handleError = () => setImgSrc(placeholderSrc);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
};

export default TournamentBadge;
